import type { CustomerExistingValuation as ExistingValuation } from '@einwert/valuation-api-client'
import { getFormattedValueAndUnitFromMonetaryValue, getFormattedValueAndUnitFromPercentage, MetricGrid } from 'ComponentLibrary'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type RentMetricGridProps = {
    valuation: ExistingValuation
}

export default function RentMetricGrid({ valuation }: RentMetricGridProps) {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tAllValues } = useTranslation('terminology', { keyPrefix: 'export.allValues' })
    const locale = useCurrentResolvedLocale()
    const values = [
        {
            ...getFormattedValueAndUnitFromMonetaryValue(valuation.tenant_summary?.total?.gross_rental_income.total, locale),
            subheadline: tCommon('grossRentalIncome'),
        },
        {
            ...getFormattedValueAndUnitFromMonetaryValue(valuation.tenant_summary?.total?.net_rental_income.total, locale),
            subheadline: tAllValues('rows.netRentalIncome'),
        },
        {
            ...getFormattedValueAndUnitFromMonetaryValue(valuation.tenant_summary?.total?.management_cost.total, locale),
            subheadline: tAllValues('rows.managementCosts'),
        },
        { ...getFormattedValueAndUnitFromPercentage(valuation.discount_rate, undefined, locale), subheadline: tCommon('discountRate') },
        {
            ...getFormattedValueAndUnitFromMonetaryValue(valuation.market_value_by_valuation_method.land_value, locale),
            subheadline: tCommon('landValue'),
        },
    ]

    return <MetricGrid numColumns={5} values={values} />
}
